export default __webpack_public_path__ + "static/media/Photo 7 - BR - Jalousies et cour intérieure.108023f4.png";